<script>
  import { Separator } from '../..'

  import { getClass } from './utils'

  export let withMargin = true

  $: className = getClass({ className: $$props.class || '' })
</script>

<div class={className}>
  <Separator key={15} size={Separator.SIZES.MEDIUM} />
  {#if withMargin}
    <Separator key={30} size={Separator.SIZES.SMALL} />
  {/if}
</div>
